module.exports = __webpack_public_path__ + "img/locationRed.4d98af02.svg";